import { render } from "./DonationGroupListPage.vue?vue&type=template&id=008925bf"
import script from "./DonationGroupListPage.vue?vue&type=script&lang=js"
export * from "./DonationGroupListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__